/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import receiveLocationGroups from './receive-location-groups';
import * as actions from 'state/action-types';

export default (locationGroupId = null) => (dispatch) => {
    return cecSdk
        .locationGroup(locationGroupId)
        .remove()
        .then(() => {
            dispatch({ type: actions.DELETE_LOCATION_GROUP_SUCCESS, payload: { locationGroupId } });
        });
};
